import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TreeTableModule } from 'primeng/treetable';
import { OsModule } from '../../rmpv/rmpv-detalhado-os/os.module';
import { ComumModule } from './../../../shared/comum.module';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { ToolbarModule } from 'primeng/toolbar';
import { PanelModule } from 'primeng/panel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { NgxFilesizeModule } from 'ngx-filesize';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BadgeModule } from 'primeng/badge';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TabViewModule } from 'primeng/tabview';
import { ApuracaoVdmAcessorioComponent } from './apuracao-vdm-acessorio.component';
import { ApuracaoVdmAcessorioHistoricoJaguarComponent } from './apuracao-vdm-acessorio-historico-jaguar/apuracao-vdm-acessorio-historico-jaguar.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { ApuracaoVdmAcessorioHistoricoLandRoverComponent } from './apuracao-vdm-acessorio-historico-land-rover/apuracao-vdm-acessorio-historico-land-rover.component';

@NgModule({
  imports: [
    HttpClientModule,
    BrowserAnimationsModule,
    TreeTableModule,
    TableModule,
    ToolbarModule,
    PanelModule,
    ConfirmDialogModule,
    NgxFilesizeModule,
    ProgressSpinnerModule,
    BadgeModule,
    ButtonModule,
    ToastModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    InputTextModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    ChartsModule,
    OsModule,
    NgbModule,
    TranslateModule.forRoot(translateLoaderNBS),
    InputSwitchModule,
    TabViewModule,
    RadioButtonModule,
    CheckboxModule
  ],
  exports: [
    ApuracaoVdmAcessorioComponent,
    ApuracaoVdmAcessorioHistoricoJaguarComponent,
    ApuracaoVdmAcessorioHistoricoLandRoverComponent
  ],
  declarations: [
    ApuracaoVdmAcessorioComponent,
    ApuracaoVdmAcessorioHistoricoJaguarComponent,
    ApuracaoVdmAcessorioHistoricoLandRoverComponent
  ],
  providers: [
    ConfirmationService,
    MessageService,
  ]
})
export class ApuracaoVDMAcessorioModule { }
